import { Component, Input, SimpleChanges } from '@angular/core';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { MenuService } from 'src/app/system-common/services/menu.service';
import { MenuItemComponent } from 'src/app/system-common/menu-item/menu-item.component';
import { NotificationService } from 'src/app/Notifications/services/notifications.service';
import { MenuItem } from 'src/app/models/common/menu-item';
import { HeaderService } from 'src/app/system-common/services/header.service';

@Component({
  selector: 'sym-menu-item-home',
  templateUrl: './menu-item-home.component.html',
  styleUrls: ['./menu-item-home.component.css'],
})
export class MenuItemHomeComponent extends MenuItemComponent {
  @Input() showMenu;
  public notificationCountResData: any = [];
  public totalNotificationCount: number;
  isCollapseMenu: boolean;
  constructor(
    public settingService: SettingService,
    public service: MenuService,
    public notificationService: NotificationService
  ) {
    super(settingService, service);
    this.totalNotificationCount = 0;
    this.isCollapseMenu = false;
  }
  ngOnInit() {
    super.ngOnInit();
    if (
      this.menu.code == 'BIRTHDAY' ||
      this.menu.code == 'LAPSEDPOLICIES' ||
      this.menu.code == 'PREMIUMDUE' ||
      this.menu.code == 'MESSAGE' ||
      this.menu.code == 'NotificationsAPI'
    )
      this.getCountNotification();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.isCollapseMenu &&
      changes['showMenu'] &&
      changes['showMenu'].previousValue === true &&
      changes['showMenu'].currentValue === false
    ) {
      this.collapseAllSubMenus(this.service.menuItems);
    } else if (
      changes['showMenu'] &&
      changes['showMenu'].previousValue === undefined &&
      changes['showMenu'].currentValue === false
    ) {
      this.collapseAllSubMenus(this.service.menuItems);
    }
  }

  collapseAllSubMenus(menuList) {
    for (let menu of menuList) {
      // Collapse all child selections
      if (menu.childList && menu.childList.length) {
        menu.isChildSelected = false;
        this.collapseAllSubMenus(menu.childList); // Recursive
      } else {
        menu.isChildSelected = false;
      }
    }
  }

  getCountNotification() {
    this.totalNotificationCount = 0;
    this.notificationService.getCountNotification().subscribe((body) => {
      let response = JSON.parse(JSON.stringify(body));
      this.notificationCountResData.push(response.data.notificationsCount);
      for (let i = 0; i < this.notificationCountResData[0].length; i++) {
        this.totalNotificationCount =
          this.totalNotificationCount + this.notificationCountResData[0][i]['notificationCount'];
      }
    });
  }

  onMenuSelected(menu?: MenuItem, parentMenu?: MenuItem) {
    if (menu.childList && menu.childList != undefined) {
      if (!this.showMenu) {
        this.isCollapseMenu = false;
        $('.btnLeftNav').trigger('click');
      }
      menu.isChildSelected = !menu.isChildSelected;
    } else if (menu.code === 'SignOutAPI') {
      this.isCollapseMenu = false;
      this.setMenuOption();
      let headerTitle = SettingService.getInjector().get(HeaderService);
      if (headerTitle.pageHeader != undefined) {
        headerTitle.pageHeader.title = null;
        headerTitle.pageHeader.additionalInfo = null;
      }
      this.settingService.logoutUser();
    } else {
      if (this.showMenu && parentMenu == undefined) {
        this.isCollapseMenu = false;
        $('.btnLeftNav').trigger('click');
      } else {
        this.isCollapseMenu = true;
      }
      this.setMenuOption();
    }
    this.closeMenu(parentMenu && parentMenu.childList ? parentMenu.childList : this.service.menuItems, menu);
  }
}
